export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Keychain - Cobalt Blue.81e31b20.jpg";